define('modules/emblue/router',['require','exports','module','jquery','backbone','modules/private/index','modules/accounts/groups/index','./view','./model'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    Private = require("modules/private/index"),
    Groups = require("modules/accounts/groups/index"),
    MainView = require("./view"),
    Emblue = require("./model");

  var init = function (tab, callback) {
    Private.init(
      function (me) {
        var group = new Groups.Model();
        var mainViewData = {
          el: "#content",
          me: me,
          group: group,
          tab: tab,
        };
        var mainView = new MainView(mainViewData);
        var productsFetch = function () {
          callback(me, group, mainView);
        };

        group.fetch({ success: productsFetch });
      },
      null,
      false
    );
  };

  var getUrlRedirect = function (redirect, query) {
    var bytesDecodificados = Uint8Array.fromBase64(redirect);
    var textoOriginal = new TextDecoder().decode(bytesDecodificados);
    var queryOriginal = "";
    if (!query) {
      return textoOriginal;
    }

    bytesDecodificados = Uint8Array.fromBase64(query);
    var queryOriginal = new TextDecoder().decode(bytesDecodificados);
    return textoOriginal + "?" + queryOriginal;
  };

  module.exports = Backbone.Router.extend({
    initialize: function () {},
    saveCps: false,
    showMigrationPhoneForm: false,
    routes: {
      "savenewcps/(:redirect)(/:query)": "saveNewCps",
      "createemblueaccount/(:redirect)(/:query)": "showPhoneForm",
    },

    saveNewCps: function (redirect, query) {
      var self = this;
      //https://signup.dev.mdirector.com/savenewcps/aHR0cHM6Ly9zaWdudXAuZGV2Lm1kaXJlY3Rvci5jb20vYWNjb3VudHM/Y29tcGFueV9pZD00MzM0OQ==
      var callback = function (me, group, mainView) {
        !self.saveCps && mainView.render();
        !self.saveCps &&
          group.save(
            {
              agreementsName: "ModifCPSv02",
            },
            {
              success: function (model) {
                var url = getUrlRedirect(redirect, query);
                window.location = url;
              },
              error: function (model, response) {
                console.info("error");
              },
            }
          );
        self.saveCps = true;
      };
      init("savenewcps", callback);
    },

    showPhoneForm: function (redirect, query) {
      var self = this;
      var returnUrl = getUrlRedirect(redirect, query);
      //https://signup.dev.mdirector.com/createemblueaccount/aHR0cHM6Ly9zaWdudXAuZGV2Lm1kaXJlY3Rvci5jb20vYWNjb3VudHM/Y29tcGFueV9pZD00MzM0OQ==

      var callback = function (me, group, mainView) {
        if (!self.showMigrationPhoneForm) {
          var emblue = new Emblue();
          emblue.set("id", group.get("id"));
          emblue.fetch({
            success: function (model) {
              mainView.emblue = model;
              mainView.returnUrl = returnUrl;
              mainView.render();
              var migrationStatus = model.get("migrationStatus");
              if (migrationStatus && migrationStatus.status == 0) {
                self.showMigrationPhoneForm = false;
                setTimeout(function () {
                  callback(me, group, mainView);
                }, 5000);
              }
            },
          });
          self.showMigrationPhoneForm = true;
        }
      };
      init("showphoneform", callback);
    },

    afterRender: function () {
      $(".i18n").i18n();
    },
  });
});

